// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/websocketnotify/v1/websocketnotify.proto" (package "c1.api.websocketnotify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export interface ChangedRef {
    /**
     * @generated from protobuf field: c1.api.websocketnotify.v1.ChangedRefEventType event_type = 1;
     */
    eventType: ChangedRefEventType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 2;
     */
    lastUpdatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any changed = 3;
     */
    changed?: Any;
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export interface AuthMessage {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export interface RefSubscription {
    /**
     * @generated from protobuf field: string ref_type = 1;
     */
    refType: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any refs = 2;
     */
    refs: Any[];
    /**
     * @generated from protobuf field: bool watch_inserts = 3;
     */
    watchInserts: boolean;
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export interface SubscribeMessage {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.websocketnotify.v1.RefSubscription ref_subscriptions = 2;
     */
    refSubscriptions: RefSubscription[];
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export interface ClientMessage {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "auth";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.AuthMessage auth = 1;
         */
        auth: AuthMessage;
    } | {
        oneofKind: "subscribe";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.SubscribeMessage subscribe = 2;
         */
        subscribe: SubscribeMessage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.websocketnotify.v1.ChangedRefEventType
 */
export enum ChangedRefEventType {
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_INSERT = 1;
     */
    INSERT = 1,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_MODIFY = 2;
     */
    MODIFY = 2,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_REMOVE = 3;
     */
    REMOVE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ChangedRef$Type extends MessageType<ChangedRef> {
    constructor() {
        super("c1.api.websocketnotify.v1.ChangedRef", [
            { no: 1, name: "event_type", kind: "enum", T: () => ["c1.api.websocketnotify.v1.ChangedRefEventType", ChangedRefEventType, "CHANGED_REF_EVENT_TYPE_"] },
            { no: 2, name: "last_updated_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "changed", kind: "message", T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export const ChangedRef = new ChangedRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthMessage$Type extends MessageType<AuthMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.AuthMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export const AuthMessage = new AuthMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefSubscription$Type extends MessageType<RefSubscription> {
    constructor() {
        super("c1.api.websocketnotify.v1.RefSubscription", [
            { no: 1, name: "ref_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "watch_inserts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export const RefSubscription = new RefSubscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscribeMessage$Type extends MessageType<SubscribeMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.SubscribeMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ref_subscriptions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RefSubscription }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export const SubscribeMessage = new SubscribeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClientMessage$Type extends MessageType<ClientMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ClientMessage", [
            { no: 1, name: "auth", kind: "message", oneof: "message", T: () => AuthMessage },
            { no: 2, name: "subscribe", kind: "message", oneof: "message", T: () => SubscribeMessage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export const ClientMessage = new ClientMessage$Type();
